import { formatDate } from '../../../lib/date'
import AddToCalendar from '../../global/AddToCalendar'
import { Detail, DetailHeading } from '../PropertyDetails.styled'
import * as S from './Inspections.styled'

const Inspections = ({ listing }) => {
  if (listing.inspections.length === 0) return null

  return (
    <Detail id='inspections'>
      <DetailHeading>Upcoming Inspections</DetailHeading>
      <S.Inspections>
        {listing.inspections.map((inspection, key) => (
          <S.Inspection key={`inspection-${key}`}>
            <S.InspectionInfo>
              <S.InspectionDate>
                {formatDate(
                  new Date(inspection.inspection_time),
                  'EEEE dd MMMM'
                )}
              </S.InspectionDate>
              <S.InspectionTime>
                {formatDate(new Date(inspection.inspection_time), 'h:mm b')} -{' '}
                {formatDate(new Date(inspection.inspection_end_time), 'h:mm b')}
              </S.InspectionTime>
            </S.InspectionInfo>
            <AddToCalendar
              text='Add to calendar'
              title={`Open for Inspection | ${listing.address}`}
              type='Auction'
              property={listing}
              start={inspection.inspection_time}
              end={inspection.inspection_end_time}
            />
          </S.Inspection>
        ))}
      </S.Inspections>
    </Detail>
  )
}

export default Inspections
